<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Unverified Reasons
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <ul
        v-for="(r, idx) in parsedReasons"
        :key="idx"
        class="fail-reason-container"
      >
        <li class="fail-reason">
          {{ r }}
        </li>
      </ul>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="reverifyHub"
      >
        Reverify
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Sending reverify request"
      overlayClass="ac-overlay"
    />
  </div>
</template>
<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'UnverifiedReasons',
  components: {
    ProcessOverlay
  },
  mixins: [customerDetailMixin],
  data(){
    return {
      processing: false,
    }
  },
  computed: {
    parsedReasons() {
      if (this.currentHub?.failReason) {
        return this.currentHub?.failReason?.split(';').filter((r) => r.trim().length > 0);
      }
      return '';
    },
  },
  methods: {
    async reverifyHub() {
      this.processing = true;
      this.$store.dispatch('reverifyHub');
      this.processing = false;
      this.toggleActionModal(true, 'few-min');
    }
  }
};
</script>

<style scoped>
.fail-reason-container {
  margin-bottom: 20px;
}
</style>
